import React, { useState, FunctionComponent } from "react";
import { Grid } from "@material-ui/core";
import { TerminalsTable } from "./TerminalsTable/TerminalsTable";
import { useStore } from "../../../store";

type terminalParams = {
  goToEdit: (editRowId: number) => void;
  editTerminalPermission: boolean;
};
export const Terminals: FunctionComponent<terminalParams> = ({
  goToEdit, editTerminalPermission
}) => {
  const [terminalsList] = useStore("terminalsList");
  const [data] = useState<any>(terminalsList);

  const handleEdit = (editRowId: number) => {
    goToEdit(editRowId);
  };

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justify="space-between"
      alignItems="center"
    >
      <Grid item xs={12}>
        <TerminalsTable
          terminal={data}
          handleEdit={handleEdit}
          editTerminalPermission={editTerminalPermission}
        />
      </Grid>
    </Grid>
  );
};
